<template>
  <div>
    <v-container class="pt-0 pb-5">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <v-btn color="primary-dark" @click="$router.go(-1)" density="compact" variant="outlined">
              <v-icon left>mdi-arrow-left</v-icon>
              Retour
            </v-btn>
            <div class="text-h6 mt-3 mb-4">Transférer votre inscription</div>
            <PendingTransfertInscription v-if="inscription.id" :id_inscription="inscription.id">
            </PendingTransfertInscription>
            <p>
              Vous vous apprêtez à transférer et perdre définitivement votre inscription à <b
                v-if="inscription.course && inscription.course.nom">{{ inscription.course.nom }}</b>.
            </p>

            <p>Aucun mouvement financier ne sera effectué sur la plate-forme. Votre inscription et vos options* seront
              transférés. Ce transfert est irréversible.</p>
            <p>*Si vous êtes inscrit à un autre parcours, vos options seront conservées.</p>
            <v-row>
              <v-col md="6">
                <FormTransfertInscriptionRecipient @onSuccess="send_transfert_request">
                </FormTransfertInscriptionRecipient>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import Inscription from "@/classes/Fiche_Coureur/Inscription.class";
import FormTransfertInscriptionRecipient from "@/components/FicheCoureur/TransfertInscription/FormTransfertInscriptionRecipient.vue";
import PendingTransfertInscription from "@/components/FicheCoureur/TransfertInscription/PendingTransfertInscription.vue";
export default {
  components: {
    PendingTransfertInscription,
    FormTransfertInscriptionRecipient,
  },
  data() {
    return {
      inscription: {},
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    async send_transfert_request(recipient) {
      const mail = this.mainStore.authUser.userMail;
      let request = await this.inscription.send_transfert_request(mail, recipient);
      if (request) {
        window.location.reload();
      }
    },
  },
  async created() {
    if (!this.mainStore.authUser.isLogged) {
      this.$router.push({ name: "FicheCoureur" });
    }
    if (!this.mainStore.module.autoriser_transfert_dossard) {
      this.$router.push({ name: "FicheCoureur" });
    }
    this.inscription = new Inscription(this.mainStore.module.id);
    this.inscription.id = this.$route.params.id_inscription;
    let request = await this.inscription.get();
    if (!request) {
      this.$router.push({ name: "FicheCoureur" });
    }
  },
};
</script>

<style lang="scss" scoped></style>